import React from "react";
import { FormattedMessage } from "@irati/utils/lang";
import id from "@irati/utils/id";
import { RouterLink } from "@irati/ui/src/Link";
import authentication from "@irati/auth";
var idNamespace = "secondaryNav";
var RecognitionMenuLink = function (_a) {
    var pathname = _a.pathname;
    var canReward = authentication.apps("recognition.rewards.create");
    var isRewardDisabled = authentication.apps("recognition.recognition.rewardDisabled");
    if (!isRewardDisabled) {
        return (React.createElement(React.Fragment, null,
            React.createElement(RouterLink, { plain: true, id: id("link-polls", idNamespace), to: "/polls", className: pathname.includes("/polls") && "active" },
                React.createElement(FormattedMessage, { id: "recognition.navigation.recognition" })),
            canReward && (React.createElement(RouterLink, { plain: true, id: id("link-reward", idNamespace), to: "/reward", className: pathname.includes("/reward") && "active" },
                React.createElement(FormattedMessage, { id: "recognition.navigation.reward" })))));
    }
    return null;
};
export default RecognitionMenuLink;
